import { ReactNode, useContext } from 'react';
import { SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { ThemeColorMode } from 'src/common/enums';
import { StyledWarnBoxContainer, StyledWarnText, StyledWarningIcon } from './warning-info-box.styles';
export const WarningInfoBox = ({
  warningText
}: {
  warningText: ReactNode;
}) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  return <StyledWarnBoxContainer isDarkMode={isDarkMode} data-testid="warning-box" data-sentry-element="StyledWarnBoxContainer" data-sentry-component="WarningInfoBox" data-sentry-source-file="warning-info-box.tsx">
      <StyledWarningIcon icon={faTriangleExclamation} data-sentry-element="StyledWarningIcon" data-sentry-source-file="warning-info-box.tsx" />
      <StyledWarnText data-sentry-element="StyledWarnText" data-sentry-source-file="warning-info-box.tsx">{warningText}</StyledWarnText>
    </StyledWarnBoxContainer>;
};